export const HOST_PARAM = 'host';
export const columnNames = {
  name: __('Name'),
  type: __('Type'),
  value: __('Value'),
  source: __('Source'),
};
export const typeOptions = [
  'string',
  'boolean',
  'integer',
  'real',
  'array',
  'hash',
  'yaml',
  'json',
];
